import { mapActions } from "vuex";
export default {
  methods: {
    ...mapActions("technician", ["deleteTechnician", "Techniciandeactive"]),
  },
};
